module.exports = __webpack_public_path__ + "media/2 cctv vid.1eb527da.mp4";